import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Typography,
} from '@mui/material';
import React, { useMemo, useState } from 'react';
import RoundedInput from '../../../components/RoundedInput';
import { HomeOwnerFilterModalStyles } from './styles';

interface HomeOwnerFilterModalProps {
  open: boolean;
  onClose: () => void;
}

const HomeOwnerFilterModal = ({ open, onClose }: HomeOwnerFilterModalProps) => {
  const [homeOwner, setHomeOwner] = useState('');
  const [email, setEmail] = useState('');
  const [location, setLocation] = useState('');
  const [purchased, setPurchased] = useState('');
  const [yearBuilt, setYearBuilt] = useState('');
  const styles = HomeOwnerFilterModalStyles();

  const isSearchButtonDisabled = useMemo(() => {
    return !(homeOwner || email || location || purchased || yearBuilt);
  }, [homeOwner, email, location, purchased, yearBuilt]);

  const handleSearchClick = () => {};

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box sx={styles.modal}>
          <Box
            display={'flex'}
            justifyContent={'space-between'}
            padding={'1.5rem'}>
            <Typography fontWeight={500}>HomeOwner Filters</Typography>
            <Button
              disabled={isSearchButtonDisabled}
              sx={styles.searchButton}
              onClick={() => handleSearchClick()}>
              Search
            </Button>
          </Box>
          <Box>
            <Grid
              container
              spacing={2}
              paddingLeft={'2rem'}
              paddingRight={'2rem'}>
              <Grid item xs={12}>
                <RoundedInput
                  size={'small'}
                  value={homeOwner}
                  label="HomeOwner name"
                  onChange={(e: any) => setHomeOwner(e.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <RoundedInput
                  size={'small'}
                  value={email}
                  label="Email"
                  onChange={(e: any) => setEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={6}>
                <RoundedInput
                  size={'small'}
                  value={location}
                  onChange={(e: any) => setLocation(e.target.value)}
                  label="Location"
                />
              </Grid>
              <Grid item xs={6}>
                <RoundedInput
                  size={'small'}
                  value={purchased}
                  onChange={(e: any) => setPurchased(e.target.value)}
                  label="Purchased"
                />
              </Grid>
              <Grid item xs={6}>
                <RoundedInput
                  size={'small'}
                  value={yearBuilt}
                  onChange={(e: any) => setYearBuilt(e.target.value)}
                  label="Year Built"
                />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default HomeOwnerFilterModal;
